import * as React from 'react';
import { ActiveFacilityContextInterface } from '../interfaces/activeFacilityInterface';
import { FacilitySelectOption } from '../types/inputProps';

export const ActiveFacilityContext = React.createContext<ActiveFacilityContextInterface>({
  facility: { label: '', value: '', isCoreMeasures: false, hasServiceCodes: false, isOutcomes: false, pixDataEntry: '0' },
  SwitchFacility: (option: FacilitySelectOption): void => console.log(option),
} as ActiveFacilityContextInterface);
